import React, { useEffect } from "react";
// DEPENDENCIES
// COMPONENTS
// STYLES

import { useLogin } from "./useAuth";

export default function LoginYC(props) {
  console.log("yo");
  const [login, { data, loading, error }] = useLogin({
    variables: { username: "yc2022@medzcool.com", password: "Ms242820" },

    onCompleted: (data) => {
      console.log(data);
      window.location.href = "/";
    },
  });

  useEffect(() => {
    login();
  }, []);

  return null;
}
